import { IconProps } from "./IconProps";

const InfoIcon = ({ size = 24, color, testID }: IconProps) => (
  <svg
    width={size}
    height={size}
    color={color}
    data-testid={testID}
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99967 0.833332C4.93326 0.833332 0.833008 4.93312 0.833008 10C0.833008 15.0663 4.9328 19.1667 9.99967 19.1667C15.0661 19.1667 19.1663 15.0669 19.1663 10C19.1663 4.93366 15.0665 0.833332 9.99967 0.833332ZM10.941 13.6388C10.941 13.9284 10.5187 14.2179 9.99985 14.2179C9.45687 14.2179 9.0708 13.9284 9.0708 13.6388V9.04158C9.0708 8.70374 9.45691 8.47443 9.99985 8.47443C10.5187 8.47443 10.941 8.70374 10.941 9.04158V13.6388ZM9.99989 7.36444C9.44484 7.36444 9.0105 6.95419 9.0105 6.49565C9.0105 6.03713 9.44488 5.63896 9.99989 5.63896C10.5429 5.63896 10.9773 6.03713 10.9773 6.49565C10.9773 6.95419 10.5428 7.36444 9.99989 7.36444Z"
      fill="#0076E2"
    />
  </svg>
);

export { InfoIcon };
